// payment支付方式
export const PAYMENT_TYPE = {
  ALIPAY: 1,
  BANK: 2,
  ENTERPRISE: 3,
};

// 认证类型，2银行上传身份证，3二要素认证
export const TYPE_ALIPAY = 3;
export const TYPE_BANK = 2;

// 认证类型 (1-个人 2-企业)
export const AUTH_TYPE = {
  PERSONAL: 1,
  ENTERPRISE: 2,
};

export const companyAuthNotice = [
  {
    content: '需提交公司信息人工审核（最晚48小时），一旦认证通过不可更改；',
  },
  {
    content: '认证通过，提现将对已认证的开户银行人工转账，48小时内到账；',
  },
  {
    content:
      '提现完成，下月提现前需提供本月增值税专用发票，否则将无法提现，发票详细内容请查看提现规则；',
  },
];

export const getPersonAuthNotice = (withdrawRule = {}) => {
  const { extraFee, feeRate } = withdrawRule;
  const defaultText = 0;
  const resExtraFeeText = extraFee ? `+${extraFee / 100}元` : '';
  const resFeeRate = feeRate ? (feeRate * 100).toFixed(2) : defaultText;
  const personAuthNotice = [
    {
      content: '需提交个人信息系统审核，一旦认证通过不可更改；',
    },
    {
      content: '认证后，可通过支付宝与银行卡进行提现，账户信息需同认证一致；',
    },
    {
      content: `提现时，支付宝免费提现，银行卡扣除${resFeeRate}%${resExtraFeeText}的服务费；`,
    },
  ];
  return personAuthNotice;
};

export const MAX_ATTACHMENT_SIZE = 500;

export const ENTERPRISE_CARD_SIDE = {
  business: 'business',
  permit: 'permit',
};

export const ID_CARD_SIDE = {
  front: 'front',
  back: 'back',
};

// status 0-未认证，1-认证中，2-认证成功，3-认证失败）
export const IDENTIFICATION_STATUS_UNAUTH = 0;
export const IDENTIFICATION_STATUS_AUTHING = 1;
export const IDENTIFICATION_STATUS_SUCCESS = 2;
export const IDENTIFICATION_STATUS_FAILED = 3;
export const IDENTIFICATION_STATUS = {
  [IDENTIFICATION_STATUS_UNAUTH]: '未认证',
  [IDENTIFICATION_STATUS_AUTHING]: '认证中',
  [IDENTIFICATION_STATUS_SUCCESS]: '认证成功',
  [IDENTIFICATION_STATUS_FAILED]: '认证失败',
};

// 验证规则
const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const regexPhone = /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
export const validationRules = {
  required: (fieldName) => ({
    validator(_, value) {
      if (!value) return Promise.reject(`请输入${fieldName}`);
      if (value.trim() === '') return Promise.reject('不能全为空格');
      return Promise.resolve();
    },
  }),
  idCard: {
    validator(_, value) {
      if (!value) return Promise.reject('请输入身份证号');
      const regexIdcard = /(^[\d*]{15}$)|(^[\d*]{18}$)|(^[\d*]{17}(\d|X|x)$)/;
      if (!regexIdcard.test(value)) return Promise.reject('请输入正确的身份证号码');
      return Promise.resolve();
    },
  },
  isAlipayAccount: {
    validator(_, value) {
      if (!value) return Promise.reject('请输入支付宝账号');
      if (!regexEmail.test(value) && !regexPhone.test(value))
        return Promise.reject('请输入正确的支付宝账号');
      return Promise.resolve();
    },
  },
  isPhone: {
    validator(_, value) {
      if (!value) return Promise.reject('请输入手机号');
      if (!regexPhone.test(value)) return Promise.reject('请输入正确的手机号');
      return Promise.resolve();
    },
  },
  isBankCard: {
    validator(_, value) {
      if (!value) return Promise.reject('请输入银行卡号');
      const regexBankCard = /^\d{12,22}$/;
      if (!regexBankCard.test(value)) return Promise.reject('请输入正确的银行卡号');
      return Promise.resolve();
    },
  },
};
